import CanvasSettingsState from "@/stores/CanvasSettingsState";
import { useDrawingStore } from "@/stores/fileStore";
import UserState from "@/stores/UserState";
import { useQueryClient } from "@tanstack/vue-query";

/**
 * mainly to avoid to create a dependency between the userstate and drawing store
 */
export const useLogout = () => {
  const queryClient = useQueryClient();
  const drawingStore = useDrawingStore();

  function logout() {
    UserState.reset();
    CanvasSettingsState.reset();
    drawingStore.clearDrawings();
    queryClient.clear();
  }

  return { logout };
};
